import { debounce } from 'lodash';
import { useRef, useEffect, useMemo } from 'react';

// Ultimate debounce react guide: https://www.developerway.com/posts/debouncing-in-react

const useDebounce = (callback: () => void) => {
  const ref = useRef<() => void>(); // Specify the type of ref

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, 300);
  }, []);

  return debouncedCallback;
};

export default useDebounce;
